import React, {
  useState,
  useEffect
}                              from 'react';
import SwiperCore, {
  Navigation,
  Pagination
}                              from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import cns                     from 'classnames';
import { useRouter }           from 'next/router';
import styles                  from './features-view.module.scss';

import ArrowBackIcon      from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon   from '@material-ui/icons/ArrowForward';
import Link               from 'next/link';
import ReviewItem         from '../../../components/Site/NewLanding/Sections/Reviews/components/ReviewItem';
import { useTranslation } from 'next-i18next';

SwiperCore.use([Navigation, Pagination]);

const FeaturesView = () => {
  const { t } = useTranslation('landing');

  const [activeTab, setActiveTab] = useState('repair');
  const [repairSwiperInstance, setRepairSwiperInstance] = useState(null);
  const [repairCurrentSlideIndex, setRepairCurrentSlideIndex] = useState(0);

  const [bookingSwiperInstance, setBookingSwiperInstance] = useState(null);
  const [bookingCurrentSlideIndex, setBookingCurrentSlideIndex] = useState(0);

  const [storeSwiperInstance, setStoreSwiperInstance] = useState(null);
  const [storeCurrentSlideIndex, setStoreCurrentSlideIndex] = useState(0);

  const [analyticsSwiperInstance, setAnalyticsSwiperInstance] = useState(null);
  const [analyticsCurrentSlideIndex, setAnalyticsCurrentSlideIndex] = useState(0);

  const router = useRouter();
  const { tab } = router.query;

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab])

  const onRepairSlideNext = () => {
    if (repairCurrentSlideIndex < 2) {
      repairSwiperInstance.slideTo(repairCurrentSlideIndex + 1);
      setRepairCurrentSlideIndex(repairCurrentSlideIndex + 1);
    }
  }

  const onRepairSlidePrev = () => {
    if (repairCurrentSlideIndex > 0) {
      repairSwiperInstance.slideTo(repairCurrentSlideIndex - 1);
      setRepairCurrentSlideIndex(repairCurrentSlideIndex - 1);
    }
  }

  const onBookingSlideNext = () => {
    if (bookingCurrentSlideIndex < 1) {
      bookingSwiperInstance.slideTo(bookingCurrentSlideIndex + 1);
      setBookingCurrentSlideIndex(bookingCurrentSlideIndex + 1);
    }
  }

  const onBookingSlidePrev = () => {
    if (bookingCurrentSlideIndex > 0) {
      bookingSwiperInstance.slideTo(bookingCurrentSlideIndex - 1);
      setBookingCurrentSlideIndex(bookingCurrentSlideIndex - 1);
    }
  }

  const onStoreSlideNext = () => {
    if (storeCurrentSlideIndex < 1) {
      storeSwiperInstance.slideTo(storeCurrentSlideIndex + 1);
      setStoreCurrentSlideIndex(storeCurrentSlideIndex + 1);
    }
  }

  const onStoreSlidePrev = () => {
    if (storeCurrentSlideIndex > 0) {
      storeSwiperInstance.slideTo(storeCurrentSlideIndex - 1);
      setStoreCurrentSlideIndex(storeCurrentSlideIndex - 1);
    }
  }

  const onAnalyticsSlideNext = () => {
    if (analyticsCurrentSlideIndex < 5) {
      analyticsSwiperInstance.slideTo(analyticsCurrentSlideIndex + 1);
      setAnalyticsCurrentSlideIndex(analyticsCurrentSlideIndex + 1);
    }
  }

  const onAnalyticsSlidePrev = () => {
    if (analyticsCurrentSlideIndex > 0) {
      analyticsSwiperInstance.slideTo(analyticsCurrentSlideIndex - 1);
      setAnalyticsCurrentSlideIndex(analyticsCurrentSlideIndex - 1);
    }
  }

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <h1 className="page-title">{t('pages.features.title')}</h1>

        <div className={styles.tabs_container}>
          <div className={styles.tabs_nav}>
            <div
              className={cns(styles.nav_item, {
                "active": activeTab === 'repair'
              })}
              onClick={() => {
                setActiveTab('repair');
              }}
            >
              {t('pages.features.tabs.workOrder')}
            </div>
            <div
              className={cns(styles.nav_item, {
                "active": activeTab === 'booking'
              })}
              onClick={() => {
                setActiveTab('booking');
              }}
            >
              {t('pages.features.tabs.booking')}
            </div>
            <div
              className={cns(styles.nav_item, {
                "active": activeTab === 'store'
              })}
              onClick={() => {
                setActiveTab('store');
              }}
            >
              {t('pages.features.tabs.stock')}
            </div>
            <div
              className={cns(styles.nav_item, {
                "active": activeTab === 'analytics'
              })}
              onClick={() => {
                setActiveTab('analytics');
              }}
            >
              {t('pages.features.tabs.analytics')}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.tabs_content_container}>
        <div className={cns(styles.tab_content, {
          "active": activeTab === 'repair'
        })}>
          <div className={styles.bg_block}/>
          <div className={styles.tab_content_container}>
            <h2 className="section-title">{t('pages.features.tabWorkOrder.title')}</h2>

            <div className={styles.controls_row}>
              <div className={styles.image_description}>
                <p>
                  {t('pages.features.tabWorkOrder.par_1')}
                </p>
                <p>
                  {t('pages.features.tabWorkOrder.part_2')}
                </p>
              </div>
              <div className={styles.controls}>
                <div className={styles.swiper_control}>
                  <div
                    className="button-prev-repair"
                    onClick={onRepairSlidePrev}
                  >
                    <ArrowBackIcon/>
                  </div>
                </div>
                <div className={styles.swiper_control}>
                  <div
                    className="button-next-repair"
                    onClick={onRepairSlideNext}
                  >
                    <ArrowForwardIcon/>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.swiper_container}>
              <div className={styles.hide_container}>
                <Swiper
                  spaceBetween={157}
                  slidesPerView={1}
                  speed={500}
                  pagination={{ clickable: true }}
                  navigation={{
                    nextEl: ".button-next-repair",
                    prevEl: ".button-prev-repair"
                  }}
                  onSwiper={setRepairSwiperInstance}
                >
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="заказ-наряд ZEN.CAR" src={'/new_promo_page/screenshots/repair_1.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="заказ-наряд ZEN.CAR" src={'/new_promo_page/screenshots/repair_2.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="заказ-наряд ZEN.CAR" src={'/new_promo_page/screenshots/repair_3.png'}/>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className={styles.hide_left}/>
                <div className={styles.hide_left_2}/>
              </div>
            </div>
          </div>
        </div>

        <div className={cns(styles.tab_content, {
          "active": activeTab === 'booking'
        })}>
          <div className={styles.bg_block}/>
          <div className={styles.tab_content_container}>
            <h2 className="section-title">{t('pages.features.tabBooking.title')}</h2>

            <div className={styles.controls_row}>
              <div className={styles.image_description}>
                <p>
                  {t('pages.features.tabBooking.part_1')}
                </p>
                <p>
                  {t('pages.features.tabBooking.part_2')}
                </p>
                <p>
                  {t('pages.features.tabBooking.part_3')}
                </p>
              </div>
              <div className={styles.controls}>
                <div className={styles.swiper_control}>
                  <div
                    className="button-prev-booking"
                    onClick={onBookingSlidePrev}
                  >
                    <ArrowBackIcon/>
                  </div>
                </div>
                <div className={styles.swiper_control}>
                  <div
                    className="button-next-booking"
                    onClick={onBookingSlideNext}
                  >
                    <ArrowForwardIcon/>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.swiper_container}>
              <div className={styles.hide_container}>
                <Swiper
                  spaceBetween={157}
                  slidesPerView={1}
                  speed={500}
                  pagination={{ clickable: true }}
                  navigation={{
                    nextEl: ".button-next-booking",
                    prevEl: ".button-prev-booking"
                  }}
                  observer={true}
                  observeParents={true}
                  onSwiper={setBookingSwiperInstance}
                >
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="запись клиента ZEN.CAR" src={'/new_promo_page/screenshots/booking.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="загрузка постов ZEN.CAR" src={'/new_promo_page/screenshots/repair_posts.png'}/>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className={styles.hide_left}/>
                <div className={styles.hide_left_2}/>
              </div>
            </div>
          </div>
        </div>

        <div className={cns(styles.tab_content, {
          "active": activeTab === 'store'
        })}>
          <div className={styles.bg_block}/>
          <div className={styles.tab_content_container}>
            <h2 className="section-title">{t('pages.features.tabStock.title')}</h2>

            <div className={styles.controls_row}>
              <div className={styles.image_description}>
                <p>
                  {t('pages.features.tabStock.part_1')}
                </p>
                <p>
                  {t('pages.features.tabStock.part_2')}
                </p>
              </div>
              <div className={styles.controls}>
                <div className={styles.swiper_control}>
                  <div
                    className="button-prev-store"
                    onClick={onStoreSlidePrev}
                  >
                    <ArrowBackIcon/>
                  </div>
                </div>
                <div className={styles.swiper_control}>
                  <div
                    className="button-next-store"
                    onClick={onStoreSlideNext}
                  >
                    <ArrowForwardIcon/>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.swiper_container}>
              <div className={styles.hide_container}>
                <Swiper
                  spaceBetween={157}
                  slidesPerView={1}
                  speed={500}
                  pagination={{ clickable: true }}
                  navigation={{
                    nextEl: ".button-next-store",
                    prevEl: ".button-prev-store"
                  }}
                  observer={true}
                  observeParents={true}
                  onSwiper={setStoreSwiperInstance}
                >
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="загрузка постов ZEN.CAR" src={'/new_promo_page/screenshots/store_1.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="загрузка постов ZEN.CAR" src={'/new_promo_page/screenshots/store_2.png'}/>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className={styles.hide_left}/>
                <div className={styles.hide_left_2}/>
              </div>
            </div>
          </div>
        </div>

        <div className={cns(styles.tab_content, {
          "active": activeTab === 'analytics'
        })}>
          <div className={styles.bg_block}/>
          <div className={styles.tab_content_container}>
            <h2 className="section-title">{t('pages.features.tabAnalytics.title')}</h2>

            <div className={styles.controls_row}>
              <div className={styles.image_description}>
                <p>
                  {t('pages.features.tabAnalytics.part_1')}
                </p>
                <p>
                  {t('pages.features.tabAnalytics.part_2')}
                </p>
              </div>
              <div className={styles.controls}>
                <div className={styles.swiper_control}>
                  <div
                    className="button-prev-analytics"
                    onClick={onAnalyticsSlidePrev}
                  >
                    <ArrowBackIcon/>
                  </div>
                </div>
                <div className={styles.swiper_control}>
                  <div
                    className="button-next-analytics"
                    onClick={onAnalyticsSlideNext}
                  >
                    <ArrowForwardIcon/>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.swiper_container}>
              <div className={styles.hide_container}>
                <Swiper
                  spaceBetween={157}
                  slidesPerView={1}
                  speed={500}
                  pagination={{ clickable: true }}
                  navigation={{
                    nextEl: ".button-next-analytics",
                    prevEl: ".button-prev-analytics"
                  }}
                  observer={true}
                  observeParents={true}
                  onSwiper={setAnalyticsSwiperInstance}
                >
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_1.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_2.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_3.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_4.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_6.png'}/>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className={styles.image_container}>
                      <img alt="Аналитика в ZEN.CAR" src={'/new_promo_page/screenshots/analytics_6.png'}/>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <div className={styles.hide_left}/>
                <div className={styles.hide_left_2}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.promo_container}>
        <div className={styles.promo_row}>
          <div className={styles.text_container}>
            <ReviewItem
              imgLink={'/new_promo_page/images/ava7.png'}
              name={t('pages.features.review.Maksim')}
              position={t('pages.features.review.MaksimPosition')}
              reviewText={t('pages.features.review.MaksimReview')}
            />
          </div>
          <div className={styles.promo_button}>
            <Link href="/access?tab=signup">
              <a className="z-button button-xl">{t('freeTrialBtn')}</a>
            </Link>
            <div>
              {t('freeTrialDescription')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturesView;